import NewPostForm from "../../../components/forms/NewPostForm";


export default function NewPostFormPage() {

    return (
        <NewPostForm />
    );
}
